<template>
    <div id="reset">
      <h2>パスワードリセット</h2>
      <hr>
      <div v-show="result">
        <div v-show="!success">
          <p class="has-text-danger">{{ errMsg }}</p>
        </div>
        <div v-show="success">
          <p class="has-text-success">{{ successMsg }}</p>
        </div>
      </div>
      <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      <div v-show="!loading && main">
        <div v-if="this.$route.query.token">
          <section>
            <b-field horizontal label="新しいパスワード">
              <b-input v-model.trim="password" type="password" maxlength="50"></b-input>
            </b-field>
            <button class="button is-primary" v-on:click="exec_reset()">送信</button>
          </section>
        </div>
        <div v-if="!this.$route.query.token">
        <section>
          <p>ユーザー登録時のメールアドレスを入力してください</p>
          <b-field horizontal label="メールアドレス">
            <b-input v-model.trim="email" type="email" maxlength="50"></b-input>
          </b-field>
          <button class="button is-primary" v-on:click="exec_prepare()">送信</button>
        </section>
      </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Reset',
  data: function () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false,
      email: '',
      password: '',
      errMsg: '不明なエラーでリセットに失敗しました。「お問い合わせ」からご連絡ください 🙏',
      successMsg: ''
    }
  },
  methods: {
    exec_prepare: function () {
      this.main = false
      this.loading = true

      this.$axios.post(this.baseURL + '/reset', {
        email: this.email
      }, {
        withCredentials: true
      }).then(() => {
        this.loading = false
        this.result = true
        this.success = true
        this.successMsg = 'メールを送信しました。メール内のリンクからパスワードの変更をしてください 😃'
      }).catch((response) => {
        if (response.response.data === 'check_user_is_registered_by_email') {
          this.errMsg = '入力されたメールアドレスは存在していません 😃'
        }
        if (response.response.data === 'bind_json') {
          this.errMsg = '内部のエラーで登録できませんでした...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'encrypt') {
          this.errMsg = 'メールアドレスの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'send_email') {
          this.errMsg = 'メールの送信に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        this.loading = false
        this.result = true
        this.success = false
      })
    },
    exec_reset: function () {
      this.main = false
      this.loading = true

      this.$axios.post(this.baseURL + '/reset?token=' + this.$route.query.token, {
        password: this.password
      }, {
        withCredentials: true
      }).then(() => {
        this.loading = false
        this.result = true
        this.success = true
        this.successMsg = 'パスワードの変更ができました🎉 ログインページを再度開いてログインしてみてください 😃'
      }).catch((response) => {
        if (response.response.data === 'bind_json') {
          this.errMsg = '内部のエラーで登録できませんでした...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'no_registered_token') {
          this.errMsg = '有効期限が切れている可能性があるので最初からお試しください 🙏'
        }
        if (response.response.data === 'get_user_by_email') {
          this.errMsg = 'ユーザー情報の取得に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'hash') {
          this.errMsg = 'パスワードの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'encrypt') {
          this.errMsg = 'メールアドレスの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        this.loading = false
        this.result = true
        this.success = true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Reset.vue